/**
 * Job status category model.
 */
export default class JobStatusCategory {
	/**
	 * Get all job status categories.
	 * @returns {JobStatusCategory[]}
	 */
	static getJobStatusCategories(): JobStatusCategory[] {
		return [
			JobStatusCategory.createCategory(JobStatusCategoryEnum.Pending),
			JobStatusCategory.createCategory(JobStatusCategoryEnum.Completed),
			JobStatusCategory.createCategory(JobStatusCategoryEnum.Cancelled)
		];
	}

	static createCategory(category: string): JobStatusCategory {
		switch (category) {
			case JobStatusCategoryEnum.Pending:
				return new JobStatusCategory("PENDING", JobStatusCategoryEnum.Pending, "Pending");
			case JobStatusCategoryEnum.Completed:
				return new JobStatusCategory("COMPLETED", JobStatusCategoryEnum.Completed, "Completed");
			case JobStatusCategoryEnum.Cancelled:
				return new JobStatusCategory("CANCELLED", JobStatusCategoryEnum.Cancelled, "Cancelled");
		}
	}

	constructor(public readonly id: string, public readonly value: string, public readonly label: string) {}
}

export enum JobStatusCategoryEnum {
	Pending = "PENDING",
	Completed = "COMPLETED",
	Cancelled = "CANCELLED"
}
